import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

import auth from './modules/auth'
import user from './modules/user'
import graduates from './modules/graduates'
import calltoaction from './modules/calltoaction'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    user,
    graduates,
    calltoaction
  },
  plugins: [
    new VuexPersistence({
      reducer: state => ({
        user: state.user,
        auth: state.auth
      })
    }).plugin
  ]
})
